// Configuración de Firebase
// Este archivo inicializa Firebase con las credenciales del proyecto
// IMPORTANTE: Las credenciales se obtienen de las variables de entorno

// Importar las funciones necesarias de Firebase
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const sanitizeEnvValue = (value) => typeof value === 'string' ? value.trim().replace(/^['"]|['"]$/g, '').trim() : value
const requiredEnv = (key) => sanitizeEnvValue(import.meta.env[key] ?? '')

// Configuración de Firebase obtenida de las variables de entorno
// Estas variables se definen en el archivo .env.local
const firebaseConfig = {
  apiKey: requiredEnv('VITE_FIREBASE_API_KEY'),
  authDomain: requiredEnv('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: requiredEnv('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: requiredEnv('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: requiredEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: requiredEnv('VITE_FIREBASE_APP_ID')
}

const missing = Object.entries(firebaseConfig).filter(([, v]) => !v).map(([k]) => k)
if (missing.length) {
  throw new Error(`Configuración de Firebase incompleta. Faltan variables: ${missing.join(', ')}`)
}

// Inicializar Firebase con la configuración
const app = initializeApp(firebaseConfig)

// Inicializar los servicios de Firebase que usaremos
// Auth: Para autenticación de usuarios
export const auth = getAuth(app)

// Firestore: Base de datos NoSQL
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false
})

// Storage: Para almacenar archivos (opcional, ya que usaremos Cloudinary)
export const storage = getStorage(app)

export const functions = getFunctions(app)

// Exportar la instancia de la app por si se necesita
export default app

